import React, { useState } from 'react'
import { FeeForm } from './FeeForm'
import { FeeTable } from './FeeTable'
import { ErrorGroup } from '../../../../_components/ErrorGroup'
import { S_FeeEditor } from './FeeEditor.styles'

//Services
import { createTerm, updateTerm } from '../../../../_services/lender.service'
import { LoaderButton } from '../../../../_components/LoaderButton'

export const FeeEditor = ({
  feeToEdit = { type: 'FeeAgeRange', entity: 1, earn_event: 3, float_days: 0 },
  businessId,
  onSave = () => {},
  ...rest
}) => {
  const [fee, setFee] = useState({
    ...feeToEdit,
    has_range_end: feeToEdit.range_end ? 'true' : 'false',
  })
  const [submitForm, setSubmitForm] = useState(() => {})
  const [errs, setErrs] = useState({})
  const [setError, setSetError] = useState(() => {})
  const [clearError, setClearError] = useState(() => {})
  const [displayedFields, setDisplayedFields] = useState([])
  const [getErrors, setGetErrors] = useState(() => {})
  const [feeForTable, setFeeForTable] = useState(feeToEdit)
  const [isLoading, setIsLoading] = useState(false)

  const getCreateType = (term) => {
    if (term.type === 'FeeRecurring' || term.type === 'FeeTiered') {
      let returnType = {}
      if (term.has_range_end === 'true') {
        returnType = { type: 'FeeTiered' }
        if (term.type === 'FeeTiered') {
          returnType.ui_type = 'EveryXDaysTiered'
        } else {
          returnType.ui_type = 'DailyRateTiered'
        }
      } else {
        returnType = { type: 'FeeRecurring' }
        if (term.type === 'FeeTiered') {
          returnType.ui_type = 'EveryXDaysRecurring'
        } else {
          returnType.ui_type = 'DailyRateRecurring'
        }
      }
      return returnType
    } else {
      return { type: term.type, ui_type: term.type }
    }
  }

  const submitFormHandler = (data) => {
    setIsLoading(true)
    let errorCopy = {}
    let allFormErrors = getErrors()
    displayedFields.map((f) => {
      if (allFormErrors[f]) {
        errorCopy[f] = allFormErrors[f]
      }
    })

    // Need to do the submit handler ourself since fields not displayed are still checked for validation

    if (!Object.keys(errorCopy).length) {
      let toCreate = { ...fee, ...data }
      if (toCreate.type === 'FeeTiered' && !toCreate.range_end) {
        toCreate.range_end = 999
      }

      // For daily rate we don't actually save the rate in the input but rather
      // that value divided by the number of days in the year.
      if (toCreate.type.includes('FeeRecurring')) {
        toCreate.value = Number(toCreate.value) / (Number(toCreate.days_in_year) || 365)
      }

      if (fee.id) {
        if ('type' in toCreate) {
          delete toCreate.type
        }
        updateTerm(fee.id, toCreate)
          .then((term) => {
            setIsLoading(false)
            onSave(term)
          })
          .catch((err) => {
            setIsLoading(false)
            if (err.data.errors) {
              setFee({ ...fee, errors: { ...fee.errors, ...err.data.errors } })
            }
          })
      } else {
        let type = getCreateType(toCreate)
        createTerm({ ...toCreate, ...type }, businessId)
          .then((term) => {
            setIsLoading(false)
            onSave(term)
          })
          .catch((err) => {
            setIsLoading(false)
            if (err.data.errors) {
              setFee({ ...fee, errors: { ...fee.errors, ...err.data.errors } })
            }
          })
      }
    }
  }

  return (
    <S_FeeEditor>
      {/* {fee.type === 'FeeAgeRange' && (
                <div className="warning" data-testid={`age-range-warning`}>
                    Please note that Age Range terms DO NOT compound on one another. The rate will only be charged if
                    the invoice is closed while it's within the start and end day range.
                </div>
            )} */}
      {fee.errors && Object.keys(fee.errors).length ? (
        <ErrorGroup
          description={''}
          errors={Object.keys(fee.errors).map((key) => fee.errors[key])}
          icon={`warningtriangle`}
          message={fee.errors[Object.keys(fee.errors)[0]]}
        />
      ) : null}
      <FeeForm
        entity={fee}
        getErrors={(fn) => setGetErrors(() => fn)}
        getFormFunctions={({ submitForm, setError, clearError }) => {
          setSubmitForm(submitForm)
          setSetError(() => setError)
          setClearError(() => clearError)
        }}
        onBlur={(id, value) => {
          // update the entity / save as needed
          if (fee.range_begin < 1) {
            setFee({ ...fee, range_begin: 1 })
            setFeeForTable({ ...fee, range_begin: 1 })
          } else {
            setFeeForTable({ ...fee })
          }
        }}
        // Pass back the new object?
        onChange={(id, newValue) => {
          const newState = { ...fee }
          newState[id] = isNaN(Number(newValue)) ? newValue : Number(newValue)
          if (id === 'has_range_end') {
            if (newValue !== 'true') {
              newState['range_end'] = null
            }
          }

          // Rules for Daily Rate fees aka 'FeeRecurring'
          if (newState.type === 'FeeRecurring') {
            // When first selecting this type set range_increment to 1
            if (id === 'type') {
              newState.range_increment = 1
            }

            // Make sure that we calculate the table right away if:
            // It is a Daily Rate and at least a value and a start day are set.
            // Then only if the fee does not end or there is an end date set.
            if (newState.value && newState.range_begin && (newState.has_range_end === 'false' || newState.range_end)) {
              setFeeForTable({ ...newState })
            }
          }

          if (fee.type === 'FeeOneTime' && id === 'earn_event' && newValue === '0') {
            newState.range_begin = 0
            newState.range_based_on = 0
          }

          setFee(newState)
          if (id === 'type' || id === 'has_range_end') {
            setFeeForTable({ ...newState })
          }
        }}
        onErrorsUpdate={(newErrors) => {
          setErrs(newErrors)
        }}
        setDisplayedFields={setDisplayedFields}
        submitHandler={submitFormHandler}
      />
      <div className={`table-save`}>
        {fee.type != 'FeeOneTime' && (
          <div className="table-wrapper" data-testid={`table-wrapper`}>
            <p className="table-title">Rate Demo Table</p>
            <FeeTable fee={feeForTable} />
            <p className="table-caption">
              The table showcases the charges applied based on the above selections. The demo table will only show rates
              calculated up to day 121. Your actual term end date is dependent on the term selections.
            </p>
          </div>
        )}
        <div className={`save-wrapper`}>
          <LoaderButton className={'save-btn'} disabled={isLoading} isLoading={isLoading} onClick={submitForm}>
            Save
          </LoaderButton>
        </div>
      </div>
    </S_FeeEditor>
  )
}
